import styled from 'styled-components';

export const ItemTitle = styled.div`
  margin-bottom: 0;
  font-weight: bold;
  font-size: 12px;
  line-height: 27px;
  color: #5B5B5B;
`;

export const IconWrapper = styled.div`
  width: 34px;
  height: 37px;
  display: flex;
  text-align: center;
  align-items: center;
  justify-content: center;
  border-radius: 3px;
  svg {
    width: 34px;
    height: 37px;
  }
`;
